module.exports = __webpack_public_path__ + "img/notification_thumbnail_default.ae058656.png";